import React from 'react';
import moment from 'moment';
import IndicatorTip from './IndicatorTip';
import DiskCard from './DiskCard';
import styles from '../index.less';

const removeDiffSec = 1 * 60 * 60;

const DiskInfo = ({ diskInfo, isX86, isDC, error, isOffline }) => {
  const { diskStatus, diskDetail } = diskInfo;
  const showError = !diskDetail || error || isOffline;
  return (
    <div className={styles['monitor-disk-info']}>
      <h1 className={styles['monitor-disk-header']}>今日磁盘状态</h1>
      {diskDetail &&
        diskDetail.length > 0 &&
        diskDetail.map((diskItem, index) => {
          const now = moment().format('X');
          const itemTime = moment(diskItem.stime).format('X');
          if (Number(now) - Number(itemTime) <= removeDiffSec) {
            return <DiskCard key={index} diskInfo={diskItem} isX86={isX86} isDC={isDC} />;
          }
        })}
      {diskDetail && diskDetail.length === 0 && !isOffline && (
        <div className={styles['none-disk']}>
          <img src={require('@/assets/images/indicator/no_disk.png')} alt="no-disk" />
          <p>暂无磁盘, 请连接</p>
        </div>
      )}
      {showError && (
        <div className={styles['error-box']}>
          <img src={require('@/assets/images/monitor/noData.png')} alt="error" />
          <p>{isOffline ? '设备离线，暂无数据' : '系统繁忙，稍后再试吧'}</p>
        </div>
      )}
      {!error && diskStatus !== undefined && diskStatus !== 0 && (
        <IndicatorTip level={2} status={diskStatus} type="disk" />
      )}
    </div>
  );
};

export default DiskInfo;
